import { render, staticRenderFns } from "./ModalLoadingPayment.vue?vue&type=template&id=13bb535a&"
import script from "./ModalLoadingPayment.vue?vue&type=script&lang=js&"
export * from "./ModalLoadingPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports